import hotelService from "@/helpers/APIService/hotel.service";
import AuthService from "@/helpers/authservice/auth.service";
import UserService from "@/helpers/APIService/user.service";

const user = JSON.parse(localStorage.getItem("user"));
const hotel = JSON.parse(localStorage.getItem("hotel"));
const rolePermission = JSON.parse(localStorage.getItem("rolePermission"));
export const state = user
  ? { status: { loggedIn: true }, user, hotel, rolePermission }
  : {
      status: { loggedIn: false },
      user: null,
      hotel: null,
      rolePermission: null,
    };

export const actions = {
  login({ commit }, user) {
    return AuthService.login(user).then(
      (user) => {
        commit("loginSuccess", user);
        return Promise.resolve(user);
      },
      (error) => {
        commit("loginFailure");
        return Promise.reject(error);
      }
    );
  },
  loginByOTP({ commit }, user) {
    return AuthService.loginWithOTP(user).then(
      (user) => {
        commit("loginSuccess", user.user_data);
        return Promise.resolve(user);
      },
      (error) => {
        commit("loginFailure");
        return Promise.reject(error);
      }
    );
  },
  refreshToken({ commit }, token) {
    return AuthService.refreshToken(token).then(
      (response) => {
        commit("tokenRefreshSuccess", response);
        return Promise.resolve(response);
      },
      (error) => {
        commit("tokenRefreshFailure");
        return Promise.reject(error);
      }
    );
  },
  setHotel({ commit }, hotel_id) {
    return hotelService.getHotelDetails(hotel_id).then(
      (hotel) => {
        commit("setHotelSuccess", hotel);
        return Promise.resolve(hotel);
      },
      (error) => {
        commit("setHotelFailure");
        return Promise.reject(error);
      }
    );
  },
  setRolePermission({ commit }, Role_id) {
    return UserService.getRolePermissionList(Role_id).then(
      (rolePermission) => {
        commit("setRolePermissionSuccess", rolePermission);
        return Promise.resolve(rolePermission);
      },
      (error) => {
        commit("setRolePermissionFailure");
        return Promise.reject(error);
      }
    );
  },
  logout({ commit }) {
    AuthService.logout();
    commit("logout");
  },
  register({ commit }, user) {
    if (user !== undefined) {
      localStorage.setItem("user", JSON.stringify(user));
      commit("registerSuccess", user);
    } else {
      commit("registerFailure");
    }
  },
};

export const mutations = {
  loginSuccess(state, user) {
    state.status.loggedIn = true;
    state.user = user;
  },
  loginFailure(state) {
    state.status.loggedIn = false;
    state.user = null;
  },
  tokenRefreshSuccess(state, token) {
    state.status.loggedIn = true;
    state.user.access = token.access;
    state.user.refresh = token.refresh;
  },
  tokenRefreshFailure(state) {
    state.status.loggedIn = false;
    state.user = null;
  },
  setHotelSuccess(state, hotel) {
    state.hotel = hotel;
  },
  setHotelFailure(state) {
    state.hotel = null;
  },
  setRolePermissionSuccess(state, rolePermission) {
    state.rolePermission = rolePermission;
  },
  setRolePermissionFailure(state) {
    state.rolePermission = null;
  },
  logout(state) {
    state.status.loggedIn = false;
    state.user = null;
    state.hotel = null;
    state.rolePermission = null;
  },
  registerSuccess(state, user) {
    state.status.loggedIn = true;
    state.user = user;
  },
  registerFailure(state) {
    state.status.loggedIn = false;
    state.user = null;
  },
};
